var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 11,
    viewBox: "0 0 95 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Linked] FieldSale"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4266 0.524178H15.2368L12.7208 10.4093H9.91064L12.4266 0.524178Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.748 4.32288L24.5053 6.41287H15.6934L16.9361 4.32288H21.3421H25.748ZM16.9361 8.38989H26.2846L25.0419 10.494H15.6934L16.9361 8.38989ZM26.1575 0.524178L24.9148 2.61417H15.6934L16.9361 0.524178H26.1575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9142 8.40401L35.506 10.4093H26.2846L27.6928 0.524178H30.2104L29.0948 8.40401H36.9142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3154 0.524176C45.3939 0.524176 48.543 1.30086 48.543 5.46673C48.543 9.61847 45.3939 10.4093 42.3154 10.4093L37.399 10.4093L38.2816 4.6618H40.9294L40.3808 8.38989H42.0895C44.0806 8.38989 45.6905 8.00861 45.6905 5.46673C45.6905 2.91072 44.0806 2.52944 42.0895 2.52944H37.5706L39.1642 0.700698L42.3154 0.524176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2341 4.00844C58.7336 4.34736 60.9883 4.40385 60.9883 6.88924C60.9883 9.26167 59.0165 10.4093 55.3732 10.4093C51.9576 10.0688 51.1235 9.97006 50.3083 8.36889L52.9561 7.4863C52.9561 8.58778 54.8361 8.24492 56.2341 8.24492C57.7593 8.24492 58.1405 7.93424 58.1405 7.27053C58.1405 6.45148 55.6038 6.23275 55.6038 6.23275C55.6038 6.23275 50.3083 5.5761 50.3083 3.58496C50.3083 1.59382 53.8104 0.0545654 57.369 0.0545654C58.3888 0.307775 59.1342 0.0545654 60.0168 2.15852L57.369 3.07331C57.369 2.40959 57.1431 2.19071 55.6038 2.19071C54.1841 2.33133 53.7072 2.61861 53.3974 3.07331C53.3974 3.90648 54.5537 3.79662 56.2341 4.00844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5063 10.4093L68.3765 2.52944L64.787 8.38989L68.1339 8.37577L67.1736 10.3952L60.9883 10.4093L67.1736 0.524178H70.5063L73.4577 10.4093H70.5063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.409 8.38989L83.1663 10.3952H73.9449L75.3531 0.51011H77.8707L76.7551 8.38995L84.409 8.38989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4635 4.22419L93.2208 6.31418H84.409L85.6517 4.22419H90.0576H94.4635ZM85.6517 8.2912H95.0002L93.7575 10.3953H84.409L85.6517 8.2912ZM94.8731 0.425489L93.6303 2.51548H84.409L85.6517 0.425489H94.8731Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "F",
    d: "M9.91401 2.6703H4.76403L4.33427 4.69523H10.2265L9.48759 6.66469H3.97739L3.38554 10.4094H0L1.83795 0.700851H10.653L9.91401 2.6703Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.0812eb8883db10032652ba3ed64834e5.svg";
export { ForwardRef as ReactComponent };